import { atom } from "jotai";

/** Map of `AppRouteKey` (see `appRoutes.ts`) → suggested prompts */
type AiAssistantRoutePromptsSuggestions = Record<string, string[]>;

export const aiAssistantRoutePromptsSuggestionsAtom =
  atom<AiAssistantRoutePromptsSuggestions>({});
